module.exports = __webpack_public_path__ + "img/alt6.29496afd.jpg";